import { application } from '../application';

import LeadFunnelController from './lead_funnel_controller';
application.register('lead-funnel', LeadFunnelController);

import CrossSellController from './cross_sell_controller';
application.register('cross-sell', CrossSellController);

import EndlessFunnelTransitionController from './endless_funnel_transition_controller';
application.register(
  'endless-funnel-transition',
  EndlessFunnelTransitionController
);

import EnhancedLoaderController from './enhanced_loader_controller';
application.register('enhanced-loader', EnhancedLoaderController);

import AnnaChatController from './anna_chat_controller';
application.register('anna-chat', AnnaChatController);

import FunnelContentController from './funnel_content_controller';
application.register('funnel-content', FunnelContentController);

// Shared Controllers

import ExitIntentController from '../pflegeplatz_controllers/exit_intent_controller';
application.register('exit-intent', ExitIntentController);
